export default "__VITE_ASSET__DA4X2868__"